import { Link, useLocation } from 'react-router-dom';
import { Home, Map, Heart, MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

const items = [
  { href: '/', label: 'Accueil', icon: Home },
  { href: '/excursions', label: 'Excursions', icon: Map },
  { href: '/a-propos', label: 'À propos', icon: Heart },
];

const WHATSAPP_URL = 'https://wa.me/5521976795050?text=Bonjour%20Cl%C3%A9a%20!';

export const MobileBottomNav = () => {
  const { pathname } = useLocation();
  // Hide on admin pages
  if (pathname.startsWith('/admin')) return null;

  return (
    <nav
      aria-label="Navigation principale mobile"
      className="xl:hidden fixed bottom-0 left-0 right-0 z-40 bg-background/95 backdrop-blur-md border-t border-border/60 pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="grid grid-cols-4 max-w-md mx-auto">
        {items.map(({ href, label, icon: Icon }) => {
          const active = href === '/' ? pathname === '/' : pathname.startsWith(href);
          return (
            <li key={href}>
              <Link
                to={href}
                className={cn(
                  'flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] text-[10px] uppercase tracking-wider font-medium transition-colors',
                  active ? 'text-roca-orange' : 'text-muted-foreground hover:text-foreground'
                )}
              >
                <Icon className="w-5 h-5" />
                {label}
              </Link>
            </li>
          );
        })}
        <li>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] text-[10px] uppercase tracking-wider font-semibold text-green-600 hover:text-green-700"
            aria-label="Contacter Cléa sur WhatsApp"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default MobileBottomNav;
